import InitComponent from 'Modules/InitComponent';
import VerifiedModal from './components/VerifiedModal.vue';
import store from 'Stores/store';
import { verifiedCategoryForRole } from './helpers';

const verifiedByLavendlaModal = document.getElementById(
  'verified-by-lavendla-modal__vue'
);

if (verifiedByLavendlaModal) {
  const initVerifiedByLavendlaModal = new InitComponent({
    selectors: verifiedByLavendlaModal,
    components: { VerifiedModal },
    template: `<VerifiedModal />`,
    store,
  });

  initVerifiedByLavendlaModal.init();
}

const verifiedByLavendla = document.getElementsByClassName(
  'counselor-top-section__verified verified-by-lavendla__vue'
);

[...verifiedByLavendla].forEach((el) => {
  el.addEventListener('click', () => {
    const role = (el as HTMLElement).dataset.role;
    store.dispatch(
      'verifiedByLavendla/toggleModal',
      verifiedCategoryForRole(role)
    );
  });
});
